import SubHeader from "../../components/elements/SubHeader";
import Sidebar from "../../components/plan-content-presets-copy/Sidebar";
import SubNav from "../../components/plan-template/SubNav";
import ListContent from "../../components/plan-content-presets-copy/ListContent";
import { useEffect, useMemo, useRef, useState } from "react";
import CopyContentModal from "../../components/popups/plan-content-presets-copy/CopyContentPopup";
import { useLoaderData } from "react-router-dom";
import LayoutSidebar from "../../components/layout/LayoutSidebar";
import CrudContentModal from "../../components/popups/plan-content-presets-copy/CrudContentPopup";
import ConfirmModal from "../../components/popups/ConfirmPopup";
import LoaderPage from "../../components/utils/LoaderPage";
import ActionBtnItem from "../../components/utils/ActionBtnItem";
import { formatOrganizationPlanCopyContentObject } from "../../helper/formatter.helper";
import { cn } from "../../lib/utils";
import {
	getAllOrganizationsList,
	getAllOrganizationTypesList,
	getAllResellersList,
} from "../../helper/data.helper";
import { OrganizationsPickerContextProvider } from "../../context/organizations-picker.context";
import usePlanContentPresetsCopy from "../../hooks/plan-content-presets-copy.hook";
import {
	getListTemplatesPlansContentPresetImportConfigurations,
	applyTemplatesPlansContentPresetImportConfiguration,
} from "../../services/plans-template-content-preset-import-configuration.service";
import useNotification from "../../hooks/notification.hook";

function PlanContentPresetsCopy() {
	const {
		loaderData: { plan: loaderPlanData, organization: loaderOrganizationData },
	} = useLoaderData();
	const { openNotification, helperErrorNotification } = useNotification();
	const [isLoadingApplyContentPreset, setIsLoadingApplyContentPreset] = useState(false);

	const organizationSelected = loaderOrganizationData?.id ? loaderOrganizationData : null;

	const {
		crudConfOpen,
		setCrudConfOpen,
		copyPopup,
		setCopyPopup,
		planChapters,
		setPlanChapters,
		planData,
		setPlanData,

		setOrganizationData,

		listConfs,
		setListConfs,

		selectedConf,
		selectedConfId,

		deleteModalOpen,
		setDeleteModalOpen,

		deleteConf,

		deleteItem,
		updateListConf,

		listOrganizations,
		setListOrganizations,

		crudModel,
		loadingCopyPlan,
		setLoadingCopyPlan,

		deleteConfRequest,
		editConfRequest,
	} = usePlanContentPresetsCopy();

	const signalCopiers = useRef(new AbortController());

	const mainCtaHandler = async () => {
		if (organizationSelected) {
			applyTemplatesPlans([organizationSelected.id]);
		} else {
			if (!listOrganizations?.length) getListOrganizations();
			if (!orgTypes?.length) getTypes();
			if (!resellers?.length) getListResellers();
			setCopyPopup(true);
		}
	};

	const templateRight = () => (
		<button
			type={"button"}
			onClick={mainCtaHandler}
			disabled={isLoadingApplyContentPreset}
			className={cn("button fill primary small", isLoadingApplyContentPreset && "loading")}
		>
			<span className="load_content">Applica</span>
			<div className="main_loader_icon fade_in"></div>
		</button>
	);

	/**
	 * Form Handler
	 * @param {form modal} data
	 */
	async function applyTemplatesPlans(selectedEntity) {
		if (selectedEntity.length > 0) {
			if (!isLoadingApplyContentPreset) {
				setIsLoadingApplyContentPreset(true);

				const body = {
					templatePlan: planData.template_plan_id,
					contentPreset: planData.content_preset_id,
					organization_plan_ids: selectedEntity,
					...(selectedConfId && { import_configuration_id: selectedConfId }),
				};

				// copy conf
				applyTemplatesPlansContentPresetImportConfiguration(
					body,
					() => {
						openNotification({
							text: "Operazione completata con successo!",
							status: "success",
						});

						setIsLoadingApplyContentPreset(false);

						setCopyPopup(false);
					},
					(err) => {
						helperErrorNotification(err);

						setIsLoadingApplyContentPreset(false);
					}
				);
			}
		}
	}

	const [orgTypes, setOrgTypes] = useState([]);

	const [resellers, setResellers] = useState([]);

	const [loadingData, setLoadingData] = useState({
		organizations: false,
		types: false,
		resellers: false,
	});

	/**
	 * Get list copiers
	 */
	const getCopiers = () => {
		signalCopiers.current.abort();
		signalCopiers.current = new AbortController();
		setLoadingCopyPlan((l) => ({ ...l, copiers: true }));
		setListConfs([]);
		const body = {
			templatePlan: loaderPlanData.plan.template_plan_id,
			contentPreset: loaderPlanData.plan.content_preset_id,
		};

		getListTemplatesPlansContentPresetImportConfigurations(
			{
				params: body,
				config: { signal: signalCopiers.current.signal },
			},
			(res) => {
				setListConfs(res.data);
				setLoadingCopyPlan((l) => ({ ...l, copiers: false }));
			}
		);
	};

	/**
	 * Get List organizations
	 */
	const getListOrganizations = async () => {
		setLoadingData((l) => ({ ...l, organizations: true }));
		const filters = {
			template_plan_id: loaderPlanData.plan.template_plan_id,
			include: ["organizationType", "reseller", "organizationPlans"],
			filter: {
				template_plan_active: true,
			},
		};
		const organizations = await getAllOrganizationsList(filters);
		setLoadingData((l) => ({ ...l, organizations: false }));
		setListOrganizations(organizations);
	};

	/**
	 * Get Types
	 */
	const getTypes = async () => {
		setLoadingData((l) => ({ ...l, types: true }));
		const types = await getAllOrganizationTypesList();
		setOrgTypes(types);
		setLoadingData((l) => ({ ...l, types: false }));
	};

	/**
	 * Get List resellers
	 */
	const getListResellers = async () => {
		// Fetch Api
		setLoadingData((l) => ({ ...l, resellers: true }));
		const resellers = await getAllResellersList();
		setResellers(resellers);
		setLoadingData((l) => ({ ...l, resellers: false }));
	};

	/**
	 * Init data
	 */
	useEffect(() => {
		setPlanChapters(loaderPlanData?.plan?.organization_contents);
		setPlanData(loaderPlanData.plan);
		setOrganizationData(loaderOrganizationData);
	}, []);

	/**
	 * Fetch data
	 */
	useEffect(() => {
		getCopiers();
	}, [updateListConf]);

	const titleSubHeader = selectedConf
		? `Configurazione – ${selectedConf.title}`
		: `Tutto il contenuto – ${loaderPlanData?.plan?.template_plan?.name}`;

	const filteredOrganizations = listOrganizations.filter(
		(corp) =>
			corp.id !== loaderPlanData.plan.organization_id &&
			corp.organization_plans.length > 0 &&
			corp.organization_plans[0].template_plan_id === loaderPlanData.plan.template_plan_id
	);

	/**
	 * Template Nav
	 * @returns
	 */
	const templateNav = () => (
		<div className="main_comp_actions_group">
			{/* Status */}
			<div className="main_list_counter">
				{/* Contents counter */}
				{selectedConf != null && (
					<div className="main_counter">
						<div className="main_icon">
							<span className="icon_16 default text_box"></span>
						</div>
						{selectedConf?.content_selections?.length}
					</div>
				)}

				{/* Requirements counter */}
				{selectedConf != null && (
					<div className="main_counter">
						<div className="main_icon">
							<span className="icon_16 default layer"></span>
						</div>
						{selectedConf?.requirement_selections?.length}
					</div>
				)}
			</div>

			{/* Actions */}
			{selectedConf != null && (
				<div className="main_actions">
					<ActionBtnItem
						icon="edit"
						onClick={() => editConfRequest(selectedConf)}
						tooltip="Modifica"
					/>

					<ActionBtnItem
						icon="delete"
						onClick={() => deleteConfRequest(selectedConf)}
						tooltip="Elimina"
					/>
				</div>
			)}
		</div>
	);

	/**
	 * Filter list
	 * @returns
	 */
	const filteredList = useMemo(() => {
		const chapters = loaderPlanData?.plan?.organization_contents
			? JSON.parse(JSON.stringify(loaderPlanData.plan.organization_contents))
			: [];

		const processed = chapters.map((chapter) => {
			const filteredContents = chapter.data.organization_contents.filter(
				(c) => c?.data?.template_chapter_content?.editable
			);
			return {
				...chapter,
				data: { ...chapter.data, organization_contents: filteredContents },
			};
		});

		return processed.filter((c) => c.data.organization_contents.length > 0);
	}, [JSON.stringify(loaderPlanData?.plan?.organization_contents)]);

	return (
		<LayoutSidebar>
			<SubHeader
				back
				backHref={`/admin/plans/template/detail/${loaderPlanData?.plan?.template_plan?.id}`}
				title="Applica contenuto"
				titleSmall
				tagElement={
					organizationSelected?.organization && {
						name: organizationSelected.organization.name,
						image: organizationSelected.organization.logo_url,
						icon: "entity",
					}
				}
				TemplateRightContent={templateRight}
				note={`${loaderPlanData?.plan?.template_plan?.name} · Preset ${loaderPlanData?.content_preset?.title}`}
			/>

			<Sidebar configurations={listConfs} disableCreate={!filteredList?.length} />

			<div className="main_page_sidebar white_page relative">
				<SubNav
					heading={titleSubHeader}
					TemplateRightContent={templateNav}
					wrapperClassName="border-b border-dark-10"
				/>

				<div
					className={`wrap_page_sidebar relative${loadingCopyPlan.showDetail ? " block_scroll" : ""}`}
				>
					{planChapters && <ListContent chapters={planChapters} />}
				</div>
				{loadingCopyPlan.showDetail && <LoaderPage title="Caricamento..." section />}
			</div>

			{/* Copy modal */}
			<OrganizationsPickerContextProvider
				organizations={filteredOrganizations}
				types={orgTypes}
				resellers={resellers}
			>
				<CopyContentModal
					organizations={filteredOrganizations}
					plan={planData}
					selectedConfId={selectedConfId}
					open={copyPopup}
					types={orgTypes}
					loadingData={loadingData}
					setOpen={setCopyPopup}
					selectedOrganizationType={loaderPlanData?.content_preset}
					isLoadingApplyContentPreset={isLoadingApplyContentPreset}
					onConfirm={async (selectedEntity) => await applyTemplatesPlans(selectedEntity)}
				/>
			</OrganizationsPickerContextProvider>

			{/* Crud modal content */}
			{planChapters && (
				<CrudContentModal
					confModel={crudModel}
					template={formatOrganizationPlanCopyContentObject(planChapters)}
					open={crudConfOpen}
					setOpen={setCrudConfOpen}
				/>
			)}

			{/* Confirm content */}
			<ConfirmModal
				open={deleteModalOpen}
				setOpen={setDeleteModalOpen}
				title={deleteConf.title}
				icon={deleteConf.icon}
				subtitle={deleteConf.subtitle}
				description={deleteConf.description}
				alertMessage="Attenzione! Questa operazione è irreversibile! <b>Sei sicuro di procedere?</b>"
				ctaLabel="Elimina"
				onConfirm={() => deleteConf.confirmHandler(deleteItem)}
			/>

			{loadingCopyPlan.planInfo && <LoaderPage title="Caricamento..." />}
		</LayoutSidebar>
	);
}

export default PlanContentPresetsCopy;
